const DEFAULT_BLOCKED_MESSAGE = "Subscription expired";

const ACCESS_REASON_MESSAGES = {
  unpaid: DEFAULT_BLOCKED_MESSAGE,
  payment_failed: DEFAULT_BLOCKED_MESSAGE,
  trial_expired: "Trial expired",
  cancel: "Subscription cancelled",
  canceled: "Subscription cancelled",
};

const isCanceledReadOnlyBillingAccess = (billingAccess) => {
  if (!billingAccess?.ui_mutations_disabled) {
    return false;
  }
  const reason = billingAccess.access_reason;
  return reason === "cancel" || reason === "canceled";
};

export const canSwitchToWorkerProvider = (provider) => {
  if (!provider) {
    return false;
  }
  const billingAccess = provider.billing_access;
  if (isCanceledReadOnlyBillingAccess(billingAccess)) {
    return false;
  }
  if (typeof provider.can_access === "boolean") {
    return provider.can_access;
  }
  if (
    billingAccess &&
    typeof billingAccess.can_worker_login === "boolean"
  ) {
    return billingAccess.can_worker_login;
  }
  return true;
};

export const getWorkerProviderSwitchBlockedMessage = (provider) => {
  const reason = provider?.billing_access?.access_reason;
  if (reason && ACCESS_REASON_MESSAGES[reason]) {
    return ACCESS_REASON_MESSAGES[reason];
  }
  return DEFAULT_BLOCKED_MESSAGE;
};

export const mapWorkerProviderFromLogin = (provider) => ({
  label: provider?.name,
  value: provider?.id,
  is_default: provider?.is_default,
  can_access: provider?.can_access,
  billing_access: provider?.billing_access ?? null,
});

export const resolveDefaultWorkerProvider = (providers) => {
  if (!Array.isArray(providers) || providers.length === 0) {
    return null;
  }

  const isDefaultFlag = (p) =>
    p.is_default === true ||
    p.is_default === "true" ||
    p.is_default === 1 ||
    p.is_default === "1";

  const defaultAccessible = providers.find(
    (p) => isDefaultFlag(p) && canSwitchToWorkerProvider(p)
  );
  if (defaultAccessible) {
    return defaultAccessible;
  }

  const firstAccessible = providers.find(canSwitchToWorkerProvider);
  if (firstAccessible) {
    return firstAccessible;
  }

  return providers[0];
};
